export default __webpack_public_path__ + "static/PlayfairDisplay-Bold-2c7ed4b21e042eeedb6feb1f57071a41.woff2";